export const helpListMixin = {
  data() {
    return {
      totalItems: 0,
      selected: [],
      selectedItems: [],
      checkedItemsAll: [],
      checkedItems: []
    }
  },
  methods: {
    collectItems(event, item) {
      if (event) {
        if (this.checkedItems.toString() === 'None') {
          this.doReset()
        }
        this.checkedItems.push(item)
        this.checkedItems.sort()
      } else {
        this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
        this.checkedItems.sort()
      }
    },
    toggleAll() {
      this.doReset()
    },
    toggleSelected() {
      this.selected = this.selectedItems.slice()
    },
    doReset() {
      this.checkedItems = []
      this.selected = []
      this.checkedItemsAll = []
    },
    doSelect(opt, caller) {
      let selectedObj = {}
      if (opt === 'None') {
        this.doReset()
        this.checkedItemsAll.push('None')
        selectedObj = {
          finalSelectedItems: this.checkedItemsAll
        }
      } else {
        if (this.checkedItems.length === 0) {
          selectedObj = {
            finalSelectedItems: ['None']
          }
        } else {
          selectedObj = {
            finalSelectedItems: this.checkedItems
          }
        }
      }
      this.$emit('doAssign', selectedObj)
      this.$emit('close', caller)
    },
    // new version of select
    enterSelect() {
      if (!this.selectedAll) {
        let templist = []
        if (this.selected.length > 0) {
          this.selected.map(data => {
            templist.push(data.key)
          })
        }
        templist.sort()
        this.checkedItems = templist
      }
      this.selectedAll = false
    },
    enterSelectAll(pagination, items, selected) {
      let pageSize = pagination.itemsPerPage
      if (selected.length === 0) {
        if (pageSize > items.length || this.checkedItems.length === items.length) {
          this.selectedAll = true
          this.checkedItems = []
        }
        if (pageSize < items.length) {
          for (let i = 0; i < pageSize; i++) {
            this.checkedItems.push(items[i].key)
          }
        }
      } else {
        this.checkedItems = []
      }
      // this.selectedAll = true
      // this.checkedItems = []
    }
  }
}
